// @ts-nocheck
import { transformUrlProxy, SLD } from '@patsnap-utils/biz';

export const PASSPORT_URI = transformUrlProxy(SLD.PASSPORT, process.env['VUE_APP_PASSPORT_URI']);
export const BO_ADMIN_URI = transformUrlProxy(SLD.ADMIN, process.env['VUE_APP_BO_ADMIN_URI']);
export const WORKSPACE_URI = transformUrlProxy(SLD.WORKSPACE, process.env['VUE_APP_WORKSPACE_URI']);
export const INSIGHTS_URI = transformUrlProxy(SLD.INSIGHTS, process.env['VUE_APP_INSIGHTS_URI']);
export const CHEMICAL_URI = transformUrlProxy(SLD.CHEMICAL, process.env['VUE_APP_CHEMICAL_URI']);
export const BIO_URI = transformUrlProxy(SLD.BIO, process.env['VUE_APP_BIO_URI']);
export const DISCOVERY_URI = transformUrlProxy(SLD.DISCOVERY, process.env['VUE_APP_DISCOVERY_URI']);
export const EUREKA_INSIGHTS_URI = transformUrlProxy(SLD.EUREKA_INSIGHTS, process.env['VUE_APP_EUREKA_INSIGHTS_URI']);
export const ANALYTICS_URI = transformUrlProxy(SLD.ANALYTICS, process.env['VUE_APP_ANALYTICS_URI']);
export const HOME_URI = transformUrlProxy(SLD.HOME, process.env['VUE_APP_HOME_URI']);
export const ACCOUNT_URI = transformUrlProxy(SLD.ACCOUNT, process.env['VUE_APP_ACCOUNT_URI']);
export const DASHBOARD_URI = transformUrlProxy(SLD.DASHBOARD, process.env['VUE_APP_DASHBOARD_URI']);
export const SYNAPSE_URI = transformUrlProxy(SLD.SYNAPSE, process.env['VUE_APP_SYNAPSE_URI']);
export const LAB_URI = transformUrlProxy(SLD.LAB, process.env['VUE_APP_LAB_URI']);
export const OPENAPI_URI = transformUrlProxy(SLD.OPEN, process.env['VUE_APP_OPENAPI_URI']);
export const EUREKA_URI = transformUrlProxy(SLD.EUREKA, process.env['VUE_APP_EUREKA_URI']);
export const CAS2_URI = process.env['VUE_APP_CAS2_URI'];

export const CHEMICAL_MARVIN_URI = process.env['VUE_APP_CHEMICAL_MARVIN_URI'];
export const WORKSPACE_SERVICE_URI = process.env['VUE_APP_WORKSPACE_SERVICE_URI'];
export const INSIGHTS_SERVICE_URI = process.env['VUE_APP_INSIGHTS_SERVICE_URI'];
export const CHEMICAL_SERVICE_URI = process.env['VUE_APP_CHEMICAL_SERVICE_URI'];
export const ACCOUNT_SERVICE_URI = process.env['VUE_APP_ACCOUNT_SERVICE_URI'];
export const DISCOVERY_SERVICE_URI = process.env['VUE_APP_DISCOVERY_SERVICE_URI'];
export const PAPER_SERVICE_URI = process.env['VUE_APP_PAPER_SERVICE_URI'];
export const HOME_SERVICE_URI = process.env['VUE_APP_HOME_SERVICE_URI'];
export const LANDSCAPE_SERVICE_URI = process.env['VUE_APP_LANDSCAPE_SERVICE_URI'];
export const LAB_SERVICE_URI = process.env['VUE_APP_LAB_SERVICE_URI'];
export const EUREKA_SERVICE_URI = process.env['VUE_APP_EUREKA_SERVICE_URI'];
export const MARKETPLACE_SERVICE_URI = process.env['VUE_APP_MARKETPLACE_SERVICE_URI'];
export const CORE_BASIC_SERVICE_URI = process.env['VUE_APP_CORE_BASIC_SERVICE_URI'];
export const CORE_SEARCH_SERVICE_URI = process.env['VUE_APP_CORE_SEARCH_SERVICE_URI'];
export const CORE_PLG_SERVICE_URI = process.env['VUE_APP_CORE_PLG_SERVICE_URI'];
export const BIO_SERVICE_URI = process.env['VUE_APP_BIO_SERVICE_URI'];
export const STATIC_COMMON_URI = process.env['VUE_APP_STATIC_COMMON_URL'];

export const DASHBOARD_SERVICE_URI = process.env['VUE_APP_DASHBOARD_SERVICE_URI'];
export const isAnalytics = process.env['VUE_APP_PASSPORT_CLIENT_NAME'] === 'analytics';
